import { getNotifications, markRead, markReadAll } from '@/services/main/notifications.service'

export default {
	namespaced: true,
	state: {
		notificationList: null,
		notificationStatus: 'pending',
		notificationTotalLatest: 0,
	},
	getters: {
		getNotificationList(state) {
			return state.notificationList || { data: [], meta: { pagination: { total: 0, current_page: 1, total_pages: 1 } } }
		},
		getNotificationStatus(state) {
			return state.notificationStatus
		},
		getNotificationTotalLatest(state) {
			return state.notificationTotalLatest
		},
	},
	mutations: {
		SET_NOTIFICATION_LIST(state, value) {
			state.notificationList = value
		},
		APPEND_NOTIFICATIONS(state, value) {
			if (!state.notificationList || !state.notificationList.data) return
			state.notificationList = {
				...state.notificationList,
				data: [...state.notificationList.data, ...value.data],
				meta: value.meta,
			}
		},
		SET_NOTIFICATION_STATUS(state, value) {
			state.notificationStatus = value
		},
		SET_NOTIFICATION_TOTAL_LATEST(state, value) {
			state.notificationTotalLatest = value
		},
		// Insere notificação no início da lista sem refetch HTTP
		PREPEND_NOTIFICATION(state, notification) {
			if (!state.notificationList || !state.notificationList.data) return
			const pagination = state.notificationList.meta && state.notificationList.meta.pagination
			state.notificationList = {
				...state.notificationList,
				data: [notification, ...state.notificationList.data],
				meta: pagination
					? {
							...state.notificationList.meta,
							pagination: { ...pagination, total: (pagination.total || 0) + 1 },
						}
					: state.notificationList.meta,
			}
		},
		INCREMENT_UNREAD_TOTAL(state) {
			const current = (state.notificationTotalLatest && state.notificationTotalLatest.total) || 0
			state.notificationTotalLatest = { ...state.notificationTotalLatest, total: current + 1 }
		},
	},
	actions: {
		async fetchNotifications({ commit }, params) {
			commit('SET_NOTIFICATION_STATUS', 'pending')
			try {
				const { data } = await getNotifications(params)
				commit('SET_NOTIFICATION_STATUS', 'init')
				commit('SET_NOTIFICATION_LIST', data)
				return data
			} catch (error) {
				commit('SET_NOTIFICATION_STATUS', 'init')
				throw error
			}
		},
		async fetchMoreNotifications({ commit }, params) {
			commit('SET_NOTIFICATION_STATUS', 'loading')
			try {
				const { data } = await getNotifications(params)
				commit('SET_NOTIFICATION_STATUS', 'init')
				commit('APPEND_NOTIFICATIONS', data)
				return data
			} catch (error) {
				commit('SET_NOTIFICATION_STATUS', 'init')
				throw error
			}
		},
		async markNotificationRead({ commit }, params) {
			commit('SET_NOTIFICATION_STATUS', 'pending')
			try {
				await markRead(params.notificationId)
				commit('SET_NOTIFICATION_STATUS', 'init')
			} catch (error) {
				commit('SET_NOTIFICATION_STATUS', 'init')
				throw error
			}
		},
		async markNotificationsReadAll({ commit }) {
			commit('SET_NOTIFICATION_STATUS', 'pending')
			try {
				await markReadAll()
				commit('SET_NOTIFICATION_STATUS', 'init')
			} catch (error) {
				commit('SET_NOTIFICATION_STATUS', 'init')
				throw error
			}
		},
		async fetchNotificationsTotalLatest({ commit }, params) {
			commit('SET_NOTIFICATION_TOTAL_LATEST', 0)
			commit('SET_NOTIFICATION_STATUS', 'pending')
			try {
				const { data } = await getNotifications(params)
				commit('SET_NOTIFICATION_STATUS', 'init')
				commit('SET_NOTIFICATION_TOTAL_LATEST', data)
				return data
			} catch (error) {
				commit('SET_NOTIFICATION_STATUS', 'init')
				throw error
			}
		},
		// Chamado pelo WebSocket ao receber nova notificação — zero requisições HTTP
		prependNotification({ commit }, notification) {
			// Normalize: websocket sends flat data, but the template expects { id, read_at, data: { ... } }
			let normalized = notification

			if (!notification.data) {
				// Laravel's BroadcastNotificationCreated::broadcastWith() merges
				// { id: <notification uuid>, type } OVER the notification payload, so the
				// flat websocket frame no longer carries the entity id the admin routes
				// need — `id` here is the notification's own UUID. Routing with it sent
				// the browser to e.g. /agency/influencers/edit/<uuid>, and the API (bigint
				// keys) answered 500. `object_id` is emitted by the backend precisely
				// because the merge leaves it alone; when it is missing we fall back to
				// no id at all, which makes generateAdminRoute() open the object's list
				// page instead of a detail page for a bogus id.
				const { id: notificationId, type, ...payload } = notification

				normalized = {
					id: notificationId,
					type,
					read_at: null,
					created_at_diff: 'just now',
					data: { ...payload, id: payload.object_id ?? null },
				}
			}

			commit('PREPEND_NOTIFICATION', normalized)
			commit('INCREMENT_UNREAD_TOTAL')
		},
	},
}
